import React, { useEffect, useState } from "react";
import { Card, ListGroup, Button, Spinner, Row, Col } from "react-bootstrap";

export default function SessionManager({
  apiBase = "/api",
  customerId,
  onSelectSession,
}) {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeSession, setActiveSession] = useState(null);

  // Load sessions when customer changes
  useEffect(() => {
    if (customerId) {
      fetchSessions();
    } else {
      setSessions([]);
      setActiveSession(null);
    }
  }, [customerId]);

  const fetchSessions = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${apiBase}/customers/${customerId}/sessions/`);
      const data = await res.json();
      setSessions(data);
    } catch (err) {
      console.error("Failed to load sessions");
    } finally {
      setLoading(false);
    }
  };

  // Create new session (frontend only)
  const handleNewSession = () => {
    setActiveSession(null);
    if (onSelectSession) onSelectSession(null);
  };

  const handleSelect = (session) => {
    setActiveSession(session.id);
    if (onSelectSession) onSelectSession(session.id);
  };

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Body>
        <Row className="mb-2 align-items-center">
          <Col>
            <h6 className="fw-semibold mb-0">Sessions</h6>
          </Col>
          <Col xs="auto">
            <Button size="sm" variant="dark" onClick={handleNewSession}>
              + New
            </Button>
          </Col>
        </Row>

        {loading ? (
          <Spinner animation="border" size="sm" />
        ) : sessions.length === 0 ? (
          <div className="text-muted small">No sessions yet</div>
        ) : (
          <ListGroup variant="flush">
            {sessions.map((s) => (
              <ListGroup.Item
                key={s.id}
                action
                active={activeSession === s.id}
                onClick={() => handleSelect(s)}
                className="d-flex justify-content-between align-items-center"
              >
                <div>
                  <div className="fw-semibold">
                    {s.title || `Session ${s.id}`}
                  </div>
                  <div className="small text-muted">
                    {new Date(s.created_at).toLocaleString()}
                  </div>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Card.Body>
    </Card>
  );
}
